__turbopack_context__.v({
  "headingPlaceholderH1": "styles-module__hCrR6q__headingPlaceholderH1",
  "headingPlaceholderH2": "styles-module__hCrR6q__headingPlaceholderH2",
  "headingPlaceholderH3": "styles-module__hCrR6q__headingPlaceholderH3",
  "nodePlaceholder": "styles-module__hCrR6q__nodePlaceholder",
});
